import Vue from 'vue'
import App from './app.vue'
import iView from 'iview'
import { router } from './router/index';
//import 'iview/dist/styles/iview.css';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Vuex from 'vuex';
import Ajax from './lib/ajax';
import Util from './lib/util'
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper'
Vue.use(iView);
//Vue.use(Vuex)
import store from './store/index';
Vue.config.productionTip = false
import { appRouters, otherRouters } from './router/router'
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
    let language = navigator.language;
    abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

Ajax.get('/AbpUserConfiguration/GetAll').then(data => {
    Util.abp = Util.extend(true, Util.abp, data.data.result);
    //过滤器
    Vue.filter('formatDate', (val:any)=>{
        if(val){
            if(val instanceof Date){
                return val.getFullYear()+'年'+(val.getMonth()+1)+'月'+val.getDate()+'日'
            }else{
                return val.substring(0,10);
            }
        }
    })
    Vue.filter('formatDateLine', (val:any)=>{
        if(val){
            if(val instanceof Date){
                return val.getFullYear()+'-'+(val.getMonth()+1)+'-'+val.getDate()
            }else{
                return val.substring(0,10);
            }
        }
    })
    Vue.filter('formatDateTime', (val:any)=>{
        if(val){
            if(val instanceof Date){
                val.getFullYear()+'-'+(val.getMonth()+1)+'-'+val.getDate()+' '+val.getHours()+':'+val.getMinutes()+':'+val.getSeconds();
            }else{
                return val.substring(0,19).replace('Z', '').replace('T', ' ');
            }
        }
    })
    new Vue({
        render: h => h(App),
        router: router,
        store: store,
        data: {
            currentPageName: ''
        },
        methods: {
            copy(arr:any){
                let obj:any = arr instanceof Array ? [] : {};
                for(let item in arr){
                    if(typeof arr[item] === "object"){
                        obj[item] = this.copy(arr[item]);
                    }else{
                        obj[item] = arr[item];
                    }
                }
                return obj;
            },
            copyObj(o:any) {  
                return Object.assign({}, o);
            },
            copyObjj(obj:any) {                
                let copy:any;
                // Handle null or undefined or function
                if (null == obj || "object" != typeof obj) return obj;
                // Handle the 3 simple types, Number and String and Boolean
                if(obj instanceof Number || obj instanceof String || obj instanceof Boolean)
                    return obj.valueOf();
                // Handle Date
                if (obj instanceof Date) {
                    copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                // Handle Array or Object
                if (obj instanceof Object || obj instanceof Array) {
                    copy = (obj instanceof Array)?[]:{};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr))
                            copy[attr] = obj[attr] ? this.copyObjj(obj[attr]) : obj[attr];
                    }
                    return copy;
                }
            },
            ResetHours(date:any) {
                return new Date(date.setHours(date.getHours()+8));
            },
            /*
             * param 将要转为URL参数字符串的对象 
             * key URL参数字符串的前缀 
             * encode true/false 是否进行URL编码,默认为true 
             *  
             * return URL参数字符串 
             */ 
            urlEncode(param:any, key:any, encode:any) {
                if (param == null) return '';
                var paramStr = '';
                var t = typeof (param);
                if (t == 'string' || t == 'number' || t == 'boolean' || (t == 'object' && param instanceof Date)) {
                    if(t == 'object' && param instanceof Date) {
                        paramStr += '&' + key + '=' + ((encode == null || encode) ? param.getFullYear()+'-'+(param.getMonth()+1)+'-'+param.getDate(): param);
                    } else {
                        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
                    }
                    
                } else {
                    for (var i in param) {
                        var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
                        paramStr += this.urlEncode(param[i], k, encode);
                    }
                }
                return paramStr;
            },
            //导出
            /*
             * searchData 筛选条件对象
             * url 导出url
             * fileName 导出文件名
             * fileExt 导出文件后缀
             */ 
            Export(searchData:any, url:any, fileName:any, fileExt:any, callback:any){
                //修改传参方式为url参数
                let params:string = this.urlEncode(searchData, null, true);
                Ajax.post(url+'?'+params, {}, {responseType: 'blob'}).then((res:any)=>{
                    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    fileName = fileName + '.' + fileExt;
                    if ('download' in document.createElement('a')) { // 非IE下载
                        const elink = document.createElement('a')
                        elink.download = fileName
                        elink.style.display = 'none'
                        elink.href = URL.createObjectURL(blob)
                        document.body.appendChild(elink)
                        elink.click()
                        URL.revokeObjectURL(elink.href) // 释放URL 对象
                        document.body.removeChild(elink)
                        if(callback){
                            callback()
                        }
                    } else { // IE10+下载
                        navigator.msSaveBlob(blob, fileName)
                        if(callback){
                            callback()
                        }
                    }
                });
            },
            //重置弹窗提交按钮loading状态
            ResetFormLoading(obj:any){
                setTimeout(() => {
                    obj = false;
                    this.$nextTick(() => {
                        obj = true;
                    });
                }, 1000);
            }
        },
        async mounted() {
            this.currentPageName = this.$route.name as string;
            //重新刷新组件
            Vue.prototype.reloadComponent = async (name:any) => {
                await this.$store.commit('app/removeTag', name);
                await this.$store.commit('app/closePage', name);
            }
            await this.$store.dispatch({
                type: 'session/init'
            })
            if (!!this.$store.state.session.user && this.$store.state.session.application.features['SignalR']) {
                if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
                    SignalRAspNetCoreHelper.initSignalR();
                }
            }
            this.$store.commit('app/initCachepage');
            this.$store.commit('app/updateMenulist');
            this.$store.commit('user/setUserInfo', data.data.result);     
            
                   
        },
        async created() {
            let tagsList: Array<any> = [];
            appRouters.map((item) => {
                if (item.children.length <= 1) {
                    tagsList.push(item.children[0]);
                } else {
                    tagsList.push(...item.children);
                }
            });
            this.$store.commit('app/setTagsList', tagsList);
            if(!this.$store.state.project.allDictionary.length){
                await this.$store.dispatch('project/GetAllDictionary')    
            }
        }
    }).$mount('#app')
})

